import React from "react";
import { apiClient } from "@/lib/auth";
import { NarratedTour } from "@/components/nds/partnerWelcome/PartnerWelcome";
import { PROSPECT_COPY, ProspectScene } from "@/components/nds/partnerWelcome/ProspectScenes";

/** Prospective-resident welcome. Desk: partners play it for the applicant. Public: pass a texted-link token. */
export function ProspectWelcome({ token, site = false, replay = false, onDone, onClose }) {
  const base = site ? "/prospect-welcome/site" : token ? `/prospect-welcome/public/${token}` : "/prospect-welcome";
  return (
    <NarratedTour load={() => apiClient.get(base)} audioPath={(n) => `${base}/audio/${n}`} Scene={ProspectScene} copy={PROSPECT_COPY}
      testid="prospect-welcome" replay={replay} closable={!token} onDone={onDone} onClose={onClose} />
  );
}
